import { React, useState } from 'react';

import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import PriceCheckRoundedIcon from '@mui/icons-material/PriceCheckRounded';

import AgreementWorkflowPage from '../../components/agreementWorkflowPage';
import SettaSwitch from '../../components/settaSwitch';

const LancarAcordo = () => {
    const [multa, setMulta] = useState(true);
    const [tipo, setTipo] = useState('boleto');

    const paymentTypeLabel = tipo === 'boleto' ? 'Boletos' : 'Pix';
    const fineLabel = multa ? 'Com multa e juros' : 'Sem multa e juros';

    return (
        <AgreementWorkflowPage
            title='Lançar Acordo'
            formId='formAcordo'
            introTitle='Composição de acordo financeiro'
            introText='Localize as contas do cliente, revise os lançamentos selecionados e defina a entrada, parcelas e primeiro vencimento.'
            submitEndpoint='gerarLancamentosAcordo'
            submitLabel='Lançar Acordo'
            submitIcon={<PriceCheckRoundedIcon />}
            attentionText='O acordo será gerado somente para as contas marcadas na tabela. Revise seleção, forma de pagamento e vencimento antes de enviar.'
            buildPayload={(payload) => ({
                ...payload,
                multa,
                tipo
            })}
            getSummaryItems={({ documento, selectedBillsCount, rows, selectedBillsTotalLabel, parcelas, dueDateLabel, dateTime }) => [
                { label: 'CPF/CNPJ', value: documento || 'Não informado', empty: !documento },
                {
                    label: 'Contas selecionadas',
                    value: `${selectedBillsCount} de ${rows.length}`,
                    empty: selectedBillsCount === 0
                },
                {
                    label: 'Valor selecionado',
                    value: selectedBillsTotalLabel,
                    empty: selectedBillsCount === 0
                },
                { label: 'Forma', value: paymentTypeLabel },
                {
                    label: 'Parcelamento',
                    value: `${parcelas || 0} parcela${Number(parcelas) === 1 ? '' : 's'}`
                },
                { label: 'Primeiro vencimento', value: dueDateLabel, empty: !dateTime }
            ]}
            renderExtraOptions={({ setParcelas }) => (
                <>
                    <Box className='agreement-workflow-options'>
                        <Box>
                            <strong>{paymentTypeLabel}</strong>
                            <span>{tipo === 'boleto' ? 'Acordo emitido em boletos.' : 'Acordo emitido por Pix em parcela única.'}</span>
                        </Box>
                        <Box className='agreement-workflow-inline-control'>
                            <SettaSwitch
                                checked={tipo === 'boleto'}
                                ariaLabel='Alternar entre boleto e Pix'
                                onChange={(checked) => {
                                    setTipo(checked ? 'boleto' : 'pix');
                                    if (!checked) {
                                        setParcelas(1);
                                    }
                                }}
                            />
                            <span>{paymentTypeLabel}</span>
                        </Box>
                    </Box>

                    <Box className='agreement-workflow-options agreement-workflow-fine-option'>
                        <Box>
                            <strong>{fineLabel}</strong>
                            <span>Controle se encargos devem compor a negociação gerada.</span>
                        </Box>
                        <Box className='agreement-workflow-inline-control'>
                            <Checkbox
                                checked={multa}
                                inputProps={{ 'aria-label': 'Incluir multa e juros' }}
                                onChange={(e) => { setMulta(e.target.checked); }}
                            />
                            <span>Encargos</span>
                        </Box>
                    </Box>
                </>
            )}
        />
    );
};

export default LancarAcordo;
